import {
  ChefHat,
  IceCream,
  LayoutDashboard,
  BarChart3,
  Gauge,
  Store,
  UtensilsCrossed,
  Map,
  Wallet,
  ArrowLeftRight,
  History,
  HeartHandshake,
  Boxes,
  Truck,
  Receipt,
  BadgeDollarSign,
  Zap,
  Building2,
  ListChecks,
  Tags,
  Utensils,
  MessageCircle,
  Users,
  ShieldCheck,
  KeyRound,
  Settings,
  Cloud,
  Database,
  FileCode,
  User,
  LogOut,
} from 'lucide-react';
import React from 'react';
import type { UserRole } from '../hooks/useRole';

export interface MenuItem {
  label: string;
  path: string;
  icon?: React.ReactElement;
  /** Legacy role filter (still used as fallback) */
  roles?: UserRole[];
  /** Permission module key – if set, item is hidden unless user can view this module */
  module?: string;
  /** Group / category for grouping in the sidebar */
  group?: 'analytics' | 'operations' | 'finance' | 'logistics' | 'management' | 'other';
}

export const menuItems: MenuItem[] = [
  // ── Dashboard e Informes ──
  { label: 'Dashboard',    path: '/dashboard',          icon: <LayoutDashboard size={20} />,   module: 'dashboard', group: 'analytics' },
  { label: 'Reportes',     path: '/reports',            icon: <BarChart3 size={20} />,         module: 'reports', group: 'analytics' },
  { label: 'KPIs',         path: '/kpi',                icon: <Gauge size={20} />,             module: 'kpi', group: 'analytics' },

  // ── Operaciones ──
  { label: 'POS',          path: '/pos',                icon: <Store size={20} />,             module: 'pos', group: 'operations' },
  { label: 'Cocina',       path: '/kitchen',            icon: <ChefHat size={20} />,           module: 'kitchen', group: 'operations' },
  { label: 'Mesas',        path: '/tables',             icon: <UtensilsCrossed size={20} />,   module: 'tables', group: 'operations' },
  { label: 'Plano',        path: '/tables/floor',       icon: <Map size={20} />,               module: 'tables', group: 'operations' },

  // ── Ventas y Finanzas ──
  { label: 'Caja',         path: '/cash',               icon: <Wallet size={20} />,            module: 'cash', group: 'finance' },
  { label: 'Movimientos',  path: '/cash/movements',     icon: <ArrowLeftRight size={20} />,    module: 'cash', group: 'finance' },
  { label: 'Historial',    path: '/orders/history',     icon: <History size={20} />,           module: 'order_history', group: 'finance' },
  { label: 'Clientes',     path: '/customers',          icon: <HeartHandshake size={20} />,    module: 'customers', group: 'finance' },

  // ── Logística y Stock ──
  { label: 'Inventario',   path: '/inventory',          icon: <Boxes size={20} />,             module: 'inventory', group: 'logistics' },
  { label: 'Compras',      path: '/purchases',          icon: <Truck size={20} />,             module: 'purchases', group: 'logistics' },
  { label: 'Gastos',       path: '/purchases/expenses',  icon: <Receipt size={20} />,           module: 'purchases', group: 'logistics' },
  { label: 'Nómina',       path: '/purchases/payroll',   icon: <BadgeDollarSign size={20} />,   module: 'purchases', group: 'logistics' },
  { label: 'Servicios',    path: '/purchases/utilities', icon: <Zap size={20} />,               module: 'purchases', group: 'logistics' },
  { label: 'Proveedores',  path: '/purchases/suppliers', icon: <Building2 size={20} />,         module: 'purchases', group: 'logistics' },
  { label: 'Mercado',      path: '/shopping',           icon: <ListChecks size={20} />,        module: 'shopping', group: 'logistics' },

  // ── Catálogo y Gestión ──
  { label: 'Categorias',   path: '/categories',         icon: <Tags size={20} />,              module: 'categories', group: 'management' },
  { label: 'Productos',    path: '/products',           icon: <Utensils size={20} />,          module: 'products', group: 'management' },
  { label: 'Sabores',      path: '/flavors',            icon: <IceCream size={20} />,          module: 'flavors', group: 'management' },
  { label: 'WhatsApp Bot', path: '/whatsapp',           icon: <MessageCircle size={20} />,     module: 'whatsapp', group: 'management' },
  { label: 'Usuarios',     path: '/users',              icon: <Users size={20} />,             module: 'users', group: 'management' },
  { label: 'Auditoría',    path: '/audit-logs',         icon: <ShieldCheck size={20} />,       module: 'users', group: 'management' },
  { label: 'Perfiles',     path: '/profiles',           icon: <KeyRound size={20} />,          module: 'settings', group: 'management' },
  { label: 'Configuración',path: '/settings',           icon: <Settings size={20} />,          module: 'settings', group: 'management' },
  { label: 'Sincronización Nube', path: '/cloud-sync',  icon: <Cloud size={20} />,             roles: ['admin'], group: 'management' },
  { label: 'Backups BD',   path: '/backups',            icon: <Database size={20} />,          roles: ['admin'], group: 'management' },
  { label: 'Swagger',      path: '/swagger',            icon: <FileCode size={20} />,          roles: ['admin'], group: 'management' },

  // ── Otros / Sin grupo (fijos al final) ──
  { label: 'Profile',      path: '/profile',            icon: <User size={20} />, group: 'other' },
  { label: 'Logout',       path: '/logout',             icon: <LogOut size={20} />, group: 'other' },
];
